import { render, staticRenderFns } from "./DynamicGroupResourceTypes.vue?vue&type=template&id=0e82ea4b&"
import script from "./DynamicGroupResourceTypes.vue?vue&type=script&lang=ts&"
export * from "./DynamicGroupResourceTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports